import { render, staticRenderFns } from "./ShoppingCartPriceSummary.vue?vue&type=template&id=bf2f82b0&scoped=true&"
import script from "./ShoppingCartPriceSummary.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartPriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartPriceSummary.vue?vue&type=style&index=0&id=bf2f82b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f82b0",
  null
  
)

export default component.exports